exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".regSelect [class~=v-select__selections]{min-height:initial !important}", "", {"version":3,"sources":["/home/webuser/salag/releases/35/spa/src/pages/auth/register/Register.scss"],"names":[],"mappings":"AAAA,yCACE,6BAAA,CAAA","file":"Register.scss?vue&type=style&index=0&prod&lang=scss&external","sourcesContent":[".regSelect [class~=\"v-select__selections\"] {\n  min-height: initial!important;\n}\n"],"sourceRoot":""}]);

// exports
